import * as React from 'react';
import { QrCode } from '../modules/PaymentMethodsList/modules/QrCode/layout/QrCode.js';

const useRenderQrForm = ()=>{
    const renderQrForm = React.useCallback(({ paymentMethodType , logoUrl , orderId , qrPaymentConfig , orderToken , handleRefreshQrCode , cart , refetch , selfUrl , paymentFlow ,  })=>{
        return /*#__PURE__*/ React.createElement(QrCode, {
            logoSettings: {
                alt: paymentMethodType,
                url: logoUrl
            },
            paymentFlow: paymentFlow,
            paymentMethodType: paymentMethodType,
            orderId: orderId,
            paymentResponse: qrPaymentConfig,
            orderToken: orderToken,
            onQrCodeRefresh: handleRefreshQrCode,
            selfUrl: selfUrl,
            refetch: refetch,
            cart: cart
        });
    }, []);
    return React.useMemo(()=>[
            renderQrForm
        ]
    , [
        renderQrForm
    ]);
};

export { useRenderQrForm };
//# sourceMappingURL=use-render-qr-form.js.map
